import Vue from "vue";
import VueI18n from "vue-i18n";

import es from "vuetify/lib/locale/es";
import pt from "vuetify/lib/locale/pt";
import { resolveInitialLocale } from "@/utils/locale";

Vue.use(VueI18n);

const messages = {
  "en-US": {
    ...require("@/locales/en-US.json"),
  },
  "pt-BR": {
    ...require("@/locales/pt-BR.json"),
    $vuetify: pt,
  },
  "es-MX": {
    ...require("@/locales/es-MX.json"),
    $vuetify: es,
  },
};

export default new VueI18n({
  locale: resolveInitialLocale(),
  fallbackLocale: "en-US",
  messages,
});
